import(/* webpackMode: "eager", webpackExports: ["ForgotPassword"] */ "/vercel/path0/apps/okgrow/src/app/[locale]/(login-pages)/forgot-password/ForgotPassword.tsx");
